import React from 'react';

const OTHER = 'OTHER';

class ColumnRenderer {
  constructor(section, userInteraction, usedAliases, extraProp = () => null) {
    this.section = section;
    this.userInteraction = userInteraction;
    this.usedAliases = usedAliases;
    this.extraProp = extraProp;
  }

  textAlignCenter() {
    return true;
  }

  keys() {
    return [...Object.keys(this.usedAliases).reverse(), OTHER];
  }

  valueToKeyMapper(columnName) {
    if (columnName.hasAlias()) {
      return columnName.alias();
    }
    return OTHER;
  }

  valueSortFunc(columnNameA, columnNameB) {
    return columnNameB.compareTo(columnNameA);
  }

  optionClicked(columnName) {
    const props = {
      section: this.section,
      columnName,
      extra: this.extraProp(columnName),
    };
    return this.userInteraction(props);
  }

  renderKey(alias) {
    if (alias === OTHER) {
      return <span>&nbsp;</span>;
    }
    const tov = this.usedAliases[alias];
    return (
      <span>
        <b>{tov.name()}</b> columns
      </span>
    );
  }

  renderValue(columnName) {
    return columnName.name();
  }
}

export default ColumnRenderer;
